"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionDimensionSDK = exports.DistributionDimension = exports.DistributionDimensionWeb = void 0;
var DistributionDimensionWeb;
(function (DistributionDimensionWeb) {
    DistributionDimensionWeb["Browser"] = "browser";
    DistributionDimensionWeb["Os"] = "os";
    DistributionDimensionWeb["BrowserVersion"] = "browserversion";
    DistributionDimensionWeb["TopBrowsers"] = "topbrowsers";
    DistributionDimensionWeb["Device"] = "device";
})(DistributionDimensionWeb = exports.DistributionDimensionWeb || (exports.DistributionDimensionWeb = {}));
exports.DistributionDimension = DistributionDimensionWeb;
var DistributionDimensionSDK;
(function (DistributionDimensionSDK) {
    DistributionDimensionSDK["ConnectivityType"] = "connectivitytype";
    DistributionDimensionSDK["ConnectivityTypeTop"] = "connectivitytypetop";
    DistributionDimensionSDK["OsVersion"] = "osversion";
    DistributionDimensionSDK["OsVersionTop"] = "osversiontop";
    DistributionDimensionSDK["AppVersion"] = "appversion";
    DistributionDimensionSDK["AppVersionTop"] = "appversiontop";
})(DistributionDimensionSDK = exports.DistributionDimensionSDK || (exports.DistributionDimensionSDK = {}));
//# sourceMappingURL=traffic.distribution.model.js.map